<template>
    <BaseInput :error="error" :required="required">
        <template slot="label">{{ label }}</template>
        <template slot="input">
            <template v-if="!tempImage">
                <ClientColorButton :size="'s'" @click.prevent="chooseImage">Upload</ClientColorButton>
                <input type="file" :accept="acceptValues" @change="loadImage" ref="imageInput" />
            </template>
            <template v-else>
                <div class="preview" @click="togglePreview(true);"><img v-if="tempImage" :src="tempImage" /></div>
                <span @click.prevent="removeImage" :title="$trad.common.remove" class="remove-button"
                    ><img src="../../../assets/effacer.png" alt=""
                /></span>
            </template>
            <ImgPreview :img="tempImage" v-if="tempImage && previewBool" @close="togglePreview(false);"></ImgPreview>
        </template>
    </BaseInput>
</template>

<script>
import ImgPreview from "@/components/ui/ImgPreview";
import BaseInput from "@/components/ui/Form/BaseInput";
import { isNotEmpty } from "@/utils/string";
import ClientColorButton from "@/components/ui/ClientColorButton";
export default {
    data: () => ({
        tempImage: undefined,
        previewBool: false,
        localErrorMessage: undefined
    }),
    components: {
        ImgPreview,
        BaseInput,
        ClientColorButton
    },
    model: {
        event: "input",
        prop: "image"
    },
    props: {
        image: {
            required: false
        },
        origin: {
            required: false,
            type: String
        },
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        accept: {
            type: Array,
            default: () => ["svg+xml", "png", "svg", "jpg"]
        },
        errorMessage: {
            type: String,
            required: false
        }
    },
    computed: {
        acceptValues() {
            return this.accept.reduce((acc, curr) => `${acc}, image/${curr}`, "").substring(2); // Le substring
            // permet de retirer le ', ' qu'on a en début de chaine;
        },
        error() {
            return this.errorMessage || this.localErrorMessage;
        }
    },
    methods: {
        togglePreview(previewValue) {
            this.previewBool = previewValue;
        },
        chooseImage() {
            this.$refs.imageInput.click();
        },
        loadImage($event) {
            this.localErrorMessage = undefined;
            const [image] = $event.target.files;
            this.tempImage = image && URL.createObjectURL(image);
            this.$emit("input", image);
        },
        removeImage() {
            this.tempImage = null;
            this.$emit("input", null);
        }
    },
    created() {
        const { image } = this;
        // L'image originale est une string, les images en cours de modif sont des objets de type FILE
        if (image && typeof image === "string") this.tempImage = this.origin;
        else if (image && typeof image === "object") this.tempImage = URL.createObjectURL(image);
    }
};
</script>

<style scoped lang="scss">
input {
    display: none;
}
.remove-button {
    display: inline-block;
    cursor: pointer;
    margin-left: 5px;
    width: 30px;
    img {
        width: 100%;
    }
}
.preview {
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    img {
        display: inline-block;
        cursor: pointer;
        height: auto;
        max-width: 140px;
        max-height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// ImageUploadBloc.vue?074d6ed5